import type { IxcInventoryV1BooksOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const INVENTORY_BOOKS_ORDER_BASE_PATH = getResolvedPath('/clearing/operations/inventory/books-order');

export const getInventoryBooksOrderPath: EntityPathBuilder<IxcInventoryV1BooksOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INVENTORY_BOOKS_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.booksOrderId) {
        return undefined;
      }

      return getResolvedPath(`${INVENTORY_BOOKS_ORDER_BASE_PATH}/$booksOrderId`, context.keys);
    }
  }
};

export function getInventoryBooksOrderDetailPath(booksOrderId: string | undefined) {
  if (!booksOrderId) {
    return undefined;
  }

  return getInventoryBooksOrderPath({ kind: 'detail', keys: { booksOrderId } });
}
